import React, { Component, Fragment } from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import { Spinner, Card, Elevation, Checkbox } from "@blueprintjs/core";
import ReconciliationFilter from "../common/ReconciliationFilter";
import { Masonry } from "../../widgets/Masonry";

import ReconciliationModal from "./modals/ReconciliationModal";

import LoadingButton from "../../widgets/LoadingButton";
import { loadProgresses } from "../../../redux/actions/progress.actions";
import { loadReconciliations } from "../../../redux/actions/reconciliation.actions";

import moment from "moment";

const CheckedCard = ({ recipient, checked, onCheckRecipient }) => {
  return (
    <div className="flex-container">
      <h3 className="flex-part">
        {recipient.first_name} {recipient.middle_name} {recipient.last_name}
      </h3>
      <Checkbox
        alignIndicator="right"
        checked={Boolean(checked)}
        onChange={onCheckRecipient}
      />
    </div>
  );
};

const RecipientCardDetails = ({ recipient, flipCard }) => {
  const renderLabeledValue = ({ label, value }) => {
    return (
      <p>
        <strong>{label}:</strong> {value}
      </p>
    );
  };
  return (
    <Fragment>
      {renderLabeledValue({
        label: "Date Of Birth",
        value: moment(recipient.dob).format("YYYY/MM/DD")
      })}
      {renderLabeledValue({ label: "E-mail", value: recipient.email })}
      {renderLabeledValue({ label: "Gender", value: recipient.gender })}
      {renderLabeledValue({
        label: "School City",
        value: recipient.city_of_school
      })}
      {renderLabeledValue({
        label: "School Country",
        value: recipient.country_of_school
      })}
      {renderLabeledValue({
        label: "Latest Education Level",
        value: recipient.latest_education_level
      })}
      {renderLabeledValue({
        label: "MEF Enrollment Date",
        value: moment(recipient.mef_enrollment_date).format("YYYY/MM/DD")
      })}
      {renderLabeledValue({ label: "Student Notes", value: recipient.notes })}
      <div className="centered">
        <button onClick={flipCard} className="pt-button pt-intent-primary">
          Show Details
        </button>
      </div>
    </Fragment>
  );
};

class ProgressCardDetails extends Component {
  componentDidMount() {
    const { id } = this.props.recipient;
    this.props.loadProgresses(id);
  }
  shouldComponentUpdate(nextProps) {
    return (
      this.props.progress.allProgressesByRecipientId !==
      nextProps.progress.allProgressesByRecipientId
    );
  }
  renderLabeledValue = ({ label, value }) => {
    return (
      <p>
        <strong>{label}:</strong> {value}
      </p>
    );
  };
  render() {
    const { flipCard } = this.props;
    const { allProgressesByRecipientId } = this.props.progress;
    const { id } = this.props.recipient;
    const progresses = allProgressesByRecipientId[id];
    return (
      <Fragment>
        <div className="spinner-container">
          {progresses ? (
            progresses.map((progress, i) => (
              <div key={i} className="progress-row">
                Progress <strong>{progress.year_begin}</strong> |{" "}
                {progress.student_status} | {progress.education_level} |{" "}
                {progress.progress_notes}
              </div>
            ))
          ) : (
            <Spinner large />
          )}
        </div>

        <div className="centered">
          <button onClick={flipCard} className="pt-button pt-intent-primary">
            Hide Details
          </button>
        </div>
      </Fragment>
    );
  }
}

class ReconciliationCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: props.checkedRecipients[props.recipient.id],
      flipped: false
    };
  }
  componentWillReceiveProps(nextProps) {
    let checked = nextProps.checkedRecipients[nextProps.recipient.id];
    this.setState({ checked });
  }
  onCheckRecipient = id => {
    this.setState(
      ({ checked }) => ({ checked: !checked }),
      () => {
        this.props.onCheckRecipient({ checked: this.state.checked, id });
      }
    );
  };
  flipCard = e => {
    e.stopPropagation();
    this.setState(({ flipped }) => ({
      flipped: !flipped
    }));
  };
  render() {
    const { recipient } = this.props;
    return (
      <div
        className={classnames("cell flip-container", {
          flip: this.state.flipped
        })}
        onTouchStart={() => this.classList.toggle("hover")}
      >
        <div className="flipper">
          <div
            className="front"
            onClick={() => this.onCheckRecipient(recipient.id)}
          >
            <Card interactive elevation={Elevation.TWO}>
              {!this.state.flipped ? (
                <Fragment>
                  <CheckedCard
                    recipient={recipient}
                    checked={this.state.checked}
                    onCheckRecipient={() => this.onCheckRecipient(recipient.id)}
                  />
                  <RecipientCardDetails
                    recipient={recipient}
                    flipCard={this.flipCard}
                  />
                </Fragment>
              ) : null}
            </Card>
          </div>
          <div className="back">
            <Card interactive elevation={Elevation.TWO}>
              {this.state.flipped ? (
                <ProgressCardDetails
                  recipient={recipient}
                  flipCard={this.flipCard}
                  checked={this.state.checked}
                  progress={this.props.progress}
                  loadProgresses={this.props.loadProgresses}
                />
              ) : null}
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const ConnectedCard = connect(
  state => ({
    progress: state.progress
  }),
  { loadProgresses }
)(ReconciliationCard);

class ReconciliationCards extends Component {
  state = {
    searchValue: ""
  };
  componentWillReceiveProps(nextProps) {
    if (this.props.checkAll !== nextProps.checkAll) {
      this.filteredReconciliations.forEach(recon => {
        if (nextProps.checkAll) {
          this.checkedRecipients[recon.id] = nextProps.checkAll;
        } else {
          delete this.checkedRecipients[recon.id];
        }
        const event = new CustomEvent("checked-reconciliation-changed", {
          detail: this.checkedRecipients
        });
        window.dispatchEvent(event);
        this.checkAll = nextProps.checkAll;
        this.forceUpdate();
      });
    }
  }
  checkedRecipients = {};
  checkAll = false;
  onCheckRecipient = ({ checked, id }) => {
    if (checked) {
      this.checkedRecipients[id] = true;
    } else {
      delete this.checkedRecipients[id];
    }
    const event = new CustomEvent("checked-reconciliation-changed", {
      detail: this.checkedRecipients
    });
    window.dispatchEvent(event);
  };
  get filteredReconciliations() {
    const { reconciliations } = this.props.reconciliation;
    const searchValue = this.state.searchValue.toLowerCase();
    return searchValue
      ? reconciliations.filter(
          recipient =>
            recipient.first_name.toLowerCase().includes(searchValue) ||
            recipient.middle_name.toLowerCase().includes(searchValue) ||
            recipient.last_name.toLowerCase().includes(searchValue)
        )
      : reconciliations;
  }
  render() {
    const filteredReconciliations = this.filteredReconciliations;
    return (
      <Fragment>
        <div className="filter-row">
          <input
            className="pt-input pt-fill"
            onChange={event =>
              this.setState({ searchValue: event.target.value })
            }
            placeholder="Search by recipient name"
            dir="auto"
          />
        </div>
        {filteredReconciliations.length ? (
          <div className="masonry-container">
            <Masonry
              list={filteredReconciliations}
              customCellRenderer={(recipient, i) => (
                <ConnectedCard
                  key={`${this.checkAll}${i}`}
                  recipient={recipient}
                  checkedRecipients={this.checkedRecipients}
                  onCheckRecipient={this.onCheckRecipient}
                />
              )}
            />
          </div>
        ) : (
          <div className="intro clear">
            <div className="intro-text">No recipients matching this name!</div>
          </div>
        )}
      </Fragment>
    );
  }
}

class ReconcileButton extends React.Component {
  state = {
    checkedReconciliations: {},
    isLoading: false
  };
  componentDidMount() {
    window.addEventListener(
      "checked-reconciliation-changed",
      this.onCheckedReconciliationsChanged
    );
  }
  componentWillUnmount() {
    window.removeEventListener(
      "checked-reconciliation-changed",
      this.onCheckedReconciliationsChanged
    );
  }
  onCheckedReconciliationsChanged = ({ detail }) => {
    this.setState({ checkedReconciliations: detail });
  };
  reconcile = () => {
    const recipient_ids = Object.keys(this.state.checkedReconciliations);
    const customEvent = new CustomEvent("open-add-reconciliation-modal", {
      detail: {
        recipient_ids
      }
    });
    window.dispatchEvent(customEvent);
  };
  render() {
    const hasCheckedReconciliation = Object.keys(
      this.state.checkedReconciliations
    ).length;
    return hasCheckedReconciliation ? (
      <div className="reconcile-btn">
        <LoadingButton
          className="pt-button pt-intent-primary pt-icon-new-person pt-large"
          isLoading={this.state.isLoading}
          onClick={this.reconcile}
          loadingText="Reconciling"
          text="Reconcile"
        />
      </div>
    ) : null;
  }
}

class Reconciliation extends Component {
  state = {
    checkAll: false
  };
  onCheckAll = () => {
    this.setState(({ checkAll }) => ({ checkAll: !checkAll }));
  };
  render() {
    const { allLoading, reconciliations } = this.props.reconciliation;
    return (
      <Fragment>
        <div className="reconciliation">
          <ReconciliationFilter
            loadData={this.props.loadReconciliations}
            allLoading={allLoading}
            checkAll={this.state.checkAll}
            hasStudentStatus
            hasDonorAssigned
            onCheckAll={this.onCheckAll}
            actionButton={<ReconcileButton />}
            {...this.props}
          />
          <div className="reconciliation-content">
            {allLoading ? (
              <div className="spinner-container">
                <Spinner large />
              </div>
            ) : reconciliations.length ? (
              <ReconciliationCards
                checkAll={this.state.checkAll}
                {...this.props}
              />
            ) : (
              <div className="intro clear">
                <div className="intro-text">
                  No reconciliations found for this date range!
                </div>
              </div>
            )}
          </div>
        </div>
        <ReconciliationModal />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  reconciliation: state.reconciliation
});

export default connect(
  mapStateToProps,
  { loadReconciliations }
)(Reconciliation);



// WEBPACK FOOTER //
// ./src/components/main/reconciliation/Reconciliation.js